module.exports = __webpack_public_path__ + "static/media/standup.8ea64ebc.gif";